import type { CfAssetDrag } from './asset'

export const DRAG_THUMB_SIZE = 104
export const DRAG_THUMB_RADIUS = 20

export function dragThumbSource(
  asset: Pick<CfAssetDrag, 'mediaType' | 'url' | 'previewUrl'>,
): string | null {
  if (asset.previewUrl) {
    return asset.previewUrl
  }
  if (asset.mediaType === 'image' && asset.url) {
    return asset.url
  }
  return null
}

export function paintDragThumb(
  canvas: HTMLCanvasElement,
  image: HTMLImageElement,
  options?: { video?: boolean },
): boolean {
  const ctx = canvas.getContext('2d')
  const sourceWidth = image.naturalWidth
  const sourceHeight = image.naturalHeight
  if (!ctx || sourceWidth <= 0 || sourceHeight <= 0) {
    return false
  }
  const size = DRAG_THUMB_SIZE
  canvas.width = size
  canvas.height = size
  ctx.clearRect(0, 0, size, size)
  ctx.save()
  ctx.beginPath()
  ctx.roundRect(0, 0, size, size, DRAG_THUMB_RADIUS)
  ctx.clip()
  const scale = Math.max(size / sourceWidth, size / sourceHeight)
  const dw = sourceWidth * scale
  const dh = sourceHeight * scale
  ctx.drawImage(image, (size - dw) / 2, (size - dh) / 2, dw, dh)
  if (options?.video) {
    paintVideoBadge(ctx, size)
  }
  ctx.restore()
  return true
}

function paintVideoBadge(ctx: CanvasRenderingContext2D, size: number) {
  const radius = 16
  const center = size - 28
  ctx.beginPath()
  ctx.arc(center, center, radius, 0, Math.PI * 2)
  ctx.fillStyle = 'rgba(0, 0, 0, 0.72)'
  ctx.fill()
  ctx.beginPath()
  ctx.moveTo(center - 5, center - 8)
  ctx.lineTo(center - 5, center + 8)
  ctx.lineTo(center + 8, center)
  ctx.closePath()
  ctx.fillStyle = '#fff'
  ctx.fill()
}
